// 선정/제외 기준(Criteria) — 추출 엔진과 템플릿 편집기가 함께 쓴다
//
// 원천: /API/studyExport 의 CriteriaDictionary(⑲) · Criteria(⑳)  (SQL: study_export_criteria.sql)
//   기준은 방문이 아니라 대상자 단위다. 키 = 종류 + 번호 ("I1" 선정 기준 1, "E3" 제외 기준 3).
//   값(CResult): 입력 화면의 예 = 1, 아니요 = 0, 답하지 않음 = 빈칸. 선정 · 제외 기준 모두 같은 규칙.

export const criteriaKey = (type, no) => `${String(type ?? '').toUpperCase()}${Number(no)}`;

/**
 * 기준 사전(⑲ 행) → 목록
 * @returns {{ inclusion: object[], exclusion: object[], byKey: Map }}
 *   항목 = { key, type, no, text, name }  name = "I1. 만 19세 이상 …" (목록 · 머리글 설명용)
 */
export function buildCriteriaCatalog(criteriaDictionary) {
  const byKey = new Map();
  for (const d of criteriaDictionary ?? []) {
    if (!d.CriteriaType || d.CriteriaNo === null || d.CriteriaNo === undefined) continue;
    const key = criteriaKey(d.CriteriaType, d.CriteriaNo);
    if (byKey.has(key)) continue;
    const text = String(d.CriteriaContents ?? '').replace(/\s+/g, ' ').trim();
    const short = text.length > 40 ? `${text.slice(0, 40)}…` : text;
    byKey.set(key, { key, type: String(d.CriteriaType).toUpperCase(), no: Number(d.CriteriaNo), text, name: `${key}. ${short}` });
  }
  const list = [...byKey.values()].sort((a, b) => a.no - b.no);
  return { inclusion: list.filter((c) => c.type === 'I'), exclusion: list.filter((c) => c.type === 'E'), byKey };
}
